export function unwrapError(err) {
    if (typeof err === 'string') {
        try {
            var parsed = JSON.parse(err);
            if (parsed.error || parsed.message || parsed.reasons) {
                return "".concat(parsed.error || parsed.reasons || parsed.message);
            }
        }
        catch (_e) {
            return err;
        }
    }
    if (Array.isArray(err)) {
        return err.map(unwrapError).join(', ');
    }
    if (typeof err === 'object' && err !== null) {
        if (Object.hasOwn(err, 'message')) {
            return unwrapError(err.message);
        }
    }
    return 'Unknown error';
}
